export default "__VITE_ASSET__b4c0987f__"